import apiUtil from './apiUtil';

// Calls for the internal admin page (/admin). Access is decided server-side by
// middleware/adminAuth.js (a fixed list of admin emails); every write is validated
// and logged there, and bad requests come back as 400 { error } for the UI to show.

const BASE = '/api/private/admin';

// Builds "?a=1&b=2" from an object, skipping empty values.
function buildQuery(params = {}) {
    const search = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value === undefined || value === null || value === '') {
            return;
        }
        search.append(key, value);
    });
    const qs = search.toString();
    return qs ? `?${qs}` : '';
}

// Table components work in (rowsPerPage, page); the API wants (limit, offset).
export function pagingParams({ rowsPerPage, page, orderBy, order }) {
    return {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
        sortField: orderBy,
        sortDir: order,
    };
}

let adminApi = {};

// 403 for anyone who is not an admin; otherwise { email }.
adminApi.getAdminInfo = function () {
    return apiUtil.runRequest({ url: `${BASE}/me`, method: 'GET' });
};

adminApi.getOverview = function () {
    return apiUtil.runRequest({ url: `${BASE}/overview`, method: 'GET' });
};

adminApi.getUsers = function (params) {
    return apiUtil.runRequest({ url: `${BASE}/users${buildQuery(params)}`, method: 'GET' });
};

adminApi.getUser = function (id) {
    return apiUtil.runRequest({ url: `${BASE}/users/${id}`, method: 'GET' });
};

adminApi.setUserPlan = function (id, plan) {
    return apiUtil.runRequest({ url: `${BASE}/users/${id}/plan`, method: 'POST', data: { plan } });
};

adminApi.setUserEndDate = function (id, endDate) {
    return apiUtil.runRequest({ url: `${BASE}/users/${id}/endDate`, method: 'POST', data: { endDate } });
};

adminApi.getStripeEvents = function (params) {
    return apiUtil.runRequest({ url: `${BASE}/stripe-events${buildQuery(params)}`, method: 'GET' });
};

adminApi.getSubscriptionTypes = function () {
    return apiUtil.runRequest({ url: `${BASE}/subscriptionTypes`, method: 'GET' });
};

adminApi.updateSubscriptionType = function (id, data) {
    return apiUtil.runRequest({ url: `${BASE}/subscriptionTypes/${id}`, method: 'PUT', data });
};

adminApi.reloadSubscriptions = function () {
    return apiUtil.runRequest({ url: `${BASE}/reloadSubscriptions`, method: 'GET' });
};

adminApi.getLessons = function (params) {
    return apiUtil.runRequest({ url: `${BASE}/lessons${buildQuery(params)}`, method: 'GET' });
};

adminApi.getSamsungAccounts = function (params) {
    return apiUtil.runRequest({ url: `${BASE}/samsung${buildQuery(params)}`, method: 'GET' });
};

adminApi.addSamsungSN = function (sn) {
    return apiUtil.runRequest({ url: `${BASE}/samsung`, method: 'POST', data: { sn } });
};

export default adminApi;
